<template>
    <gz-auth-view-template>
        <!-- <section class="gz-notification__section" slot="above-title" >
        </section> -->
        <GZ-StaticNotification slot="above-title" />

        <GZ-PageTitle :title="`Адрес №: ${$route.params.id}`" slot="title"/> 

        <section slot="under-title">
            <AddressCard/>
        </section>

        <section slot="above-content" class="gz-tabs gz-tabs__section">
            <router-link 
                :to="`/admin/address/${$route.params.id}/view-all`" 
                class="gz-tabs__item"
            >Список помещений</router-link>
            <router-link 
                :to="`/admin/address/${$route.params.id}/schedule`" 
                class="gz-tabs__item"
            >Проверки</router-link>
            <router-link 
                :to="`/admin/address/${$route.params.id}/edit`" 
                class="gz-tabs__item"
            >Редактировать</router-link>
        </section>

        <section slot="content">
            <router-view></router-view>
        </section>
    </gz-auth-view-template>
</template>

<script>
import AddressCard from '@/components/custom/admin/views/addresses/AddressCard'

export default {
    name: 'AddressesSingle',
    
    components: {
        AddressCard
    }
}
</script>